import runa1 from '../assets/images/runa/1.png';
import runa2 from '../assets/images/runa/2.png';
import runa3 from '../assets/images/runa/3.png';
import runa4 from '../assets/images/runa/4.png';
import runa5 from '../assets/images/runa/5.png';
import runa6 from '../assets/images/runa/6.png';
import runa7 from '../assets/images/runa/7.png';
import runa8 from '../assets/images/runa/8.png';
import runa9 from '../assets/images/runa/9.png';
import runa10 from '../assets/images/runa/10.png';
import runa11 from '../assets/images/runa/11.png';
import runa12 from '../assets/images/runa/12.png';
import runa13 from '../assets/images/runa/13.png';
import runa14 from '../assets/images/runa/14.png';
import runa15 from '../assets/images/runa/15.png';
import runa16 from '../assets/images/runa/16.png';
import runa17 from '../assets/images/runa/17.png';
import runa18 from '../assets/images/runa/18.png';
import runa19 from '../assets/images/runa/19.png';
import runa20 from '../assets/images/runa/20.png';
import runa21 from '../assets/images/runa/21.png';
import runa22 from '../assets/images/runa/22.png';
import runa23 from '../assets/images/runa/23.png';
import runa24 from '../assets/images/runa/24.png';
import runa25 from '../assets/images/runa/25.png';
import runa26 from '../assets/images/runa/26.png';
import runa27 from '../assets/images/runa/27.png';
import runa28 from '../assets/images/runa/28.png';
import runa29 from '../assets/images/runa/29.png';
import runa30 from '../assets/images/runa/30.png';
import runa31 from '../assets/images/runa/31.png';
import runa32 from '../assets/images/runa/32.png';
import runa33 from '../assets/images/runa/33.png';
import runa34 from '../assets/images/runa/34.png';
import runa35 from '../assets/images/runa/35.png';
import runa36 from '../assets/images/runa/36.png';
import runa37 from '../assets/images/runa/37.png';
import runa38 from '../assets/images/runa/38.png';
import runa39 from '../assets/images/runa/39.png';
import runa40 from '../assets/images/runa/40.png';
import runa41 from '../assets/images/runa/41.png';
import runa42 from '../assets/images/runa/42.png';
import runa43 from '../assets/images/runa/43.png';
import runa44 from '../assets/images/runa/44.png';
import runa45 from '../assets/images/runa/45.png';
import runa46 from '../assets/images/runa/46.png';
import runa47 from '../assets/images/runa/47.png';
import runa48 from '../assets/images/runa/48.png';
import runa49 from '../assets/images/runa/49.png';
import runa50 from '../assets/images/runa/50.png';
import runa51 from '../assets/images/runa/51.png';
import runa52 from '../assets/images/runa/52.png';
import runa53 from '../assets/images/runa/53.png';
import runa54 from '../assets/images/runa/54.png';
import runa55 from '../assets/images/runa/55.png';
import runa56 from '../assets/images/runa/56.png';
import runa57 from '../assets/images/runa/57.png';
import runa58 from '../assets/images/runa/58.png';
import runa59 from '../assets/images/runa/59.png';
import runa60 from '../assets/images/runa/60.png';
import runa61 from '../assets/images/runa/61.png';
import runa62 from '../assets/images/runa/62.png';
import runa63 from '../assets/images/runa/63.png';
import runa64 from '../assets/images/runa/64.png';

export default [
    runa1,
    runa2,
    runa3,
    runa4,
    runa5,
    runa6,
    runa7,
    runa8,
    runa9,
    runa10,
    runa11,
    runa12,
    runa13,
    runa14,
    runa15,
    runa16,
    runa17,
    runa18,
    runa19,
    runa20,
    runa21,
    runa22,
    runa23,
    runa24,
    runa25,
    runa26,
    runa27,
    runa28,
    runa29,
    runa30,
    runa31,
    runa32,
    runa33,
    runa34,
    runa35,
    runa36,
    runa37,
    runa38,
    runa39,
    runa40,
    runa41,
    runa42,
    runa43,
    runa44,
    runa45,
    runa46,
    runa47,
    runa48,
    runa49,
    runa50,
    runa51,
    runa52,
    runa53,
    runa54,
    runa55,
    runa56,
    runa57,
    runa58,
    runa59,
    runa60,
    runa61,
    runa62,
    runa63,
    runa64,
];